import React from 'react';
import { Button } from 'antd';
import { ButtonProps } from 'antd/es/button';
import { useResponsiveSizes } from '../../../hooks/use-responsive-sizes';

export const BrandButton: React.FC<ButtonProps> = ({ loading, disabled, children, ...props }) => {
  const { fontSize, screens, spacing } = useResponsiveSizes();
  const isDisabled = loading || disabled;
  const buttonHeight = screens.xs ? 40 : screens.sm ? 44 : 48;
  const buttonFontSize = screens.xs ? fontSize.xl : fontSize.lg;

  return (
    <>
      <Button
        {...props}
        loading={loading}
        disabled={disabled}
        style={{
          width: '100%',
          height: buttonHeight,
          padding: `0 ${spacing.md}px`,
          background: isDisabled ? '#f5f5f5' : 'linear-gradient(135deg, #333F83 0%, #9A218C 100%)',
          color: isDisabled ? '#999' : '#fff',
          border: isDisabled ? '1px solid #e0e0e0' : 'none',
          borderRadius: screens.xs ? 8 : 12,
          fontSize: buttonFontSize,
          fontWeight: 700,
          cursor: isDisabled ? 'not-allowed' : 'pointer',
          boxShadow: isDisabled ? 'none' : '0 8px 25px rgba(154, 33, 140, 0.25)',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          overflow: 'hidden',
          userSelect: 'none'
        }}
        onMouseEnter={e => {
          if (!isDisabled) {
            (e.target as HTMLElement).style.background = 'linear-gradient(135deg, #4A5A9D 0%, #B8329F 100%)';
            (e.target as HTMLElement).style.transform = 'scale(1.02)';
          }
        }}
        onMouseLeave={e => {
          if (!isDisabled) {
            (e.target as HTMLElement).style.background = 'linear-gradient(135deg, #333F83 0%, #9A218C 100%)';
            (e.target as HTMLElement).style.transform = 'scale(1)';
          }
        }}
      >
        <span style={{ position: 'relative', zIndex: 2 }}>{children}</span>
        {!isDisabled && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: '-100%',
              width: '100%',
              height: '100%',
              animation: 'shimmer 2s infinite',
              zIndex: 1
            }}
          />
        )}
      </Button>
    </>
  );
};
